import { useGraphqlQuery } from "@bsm/component";
import { TSignatory } from "@bsm/graphql";
import InvoiceSignatoryDetailsQuery from "../queries/InvoiceSignatoryDetailsQuery";

export const useInvoiceDetailsQuery = (id?: number, suspense?: boolean) => {
    return useGraphqlQuery<InvoiceSignatoryDetailsQuery, TSignatory>(
        new InvoiceSignatoryDetailsQuery({ id }),
        { enabled: !!id, suspense }
    );
};
